import { setPageTitle } from '@/infrastructure/mixins/dynamicPageTitle'
import { NavigationGuardNext, Route } from 'vue-router'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  setPageTitle(to)
  next()
}
